import { getISOWeek as a } from "./getISOWeek.js";
import { toDate as f } from "./toDate.js";
function i(e, o) {
  const t = f(e), r = a(t) - o;
  return t.setDate(t.getDate() - r * 7), t;
}
export {
  i as default,
  i as setISOWeek
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setISOWeek.js
// module id = 1397
// module chunks = 41